import React, { useState, useContext } from "react";
import { useSelector } from "react-redux";
import axios from "axios";
import { api_url } from "../utils/config";
import { LanguageContext } from "../context/LanguageContext";

const Chapa = ({ price, orderId, shippingInfo }) => {
  const [loading, setLoading] = useState(false);
  const { t } = useContext(LanguageContext);
  const { userInfo } = useSelector((state) => state.auth);

  const initiate_payment = async () => {
    setLoading(true);
    try {
      console.log("Initiating payment with:", { price, orderId, shippingInfo });

      const { data } = await axios.post(
        `${api_url}/api/order/create-payment`,
        {
          price,
          orderId: orderId || localStorage.getItem("orderId"),
          email: userInfo?.email || "customer@gmail.com",
          firstName: shippingInfo?.name?.split(" ")[0] || "Customer",
          lastName: shippingInfo?.name?.split(" ")[1] || "",
          phone: shippingInfo?.phone || "0911111111",
        },
        { withCredentials: true },
      );

      console.log("Payment response:", data);

      if (data.checkout_url) {
        // Store orderId and txRef for later receipt/confirm pages
        if (orderId) {
          localStorage.setItem("orderId", orderId);
        }
        if (data.tx_ref) {
          localStorage.setItem("chapaTxRef", data.tx_ref);
        }
        window.location.href = data.checkout_url;
      } else {
        console.error("Payment initialization failed:", data);
        alert(
          data.message ||
            t("paymentInitializationFailed") ||
            "Payment initialization failed. Please try again.",
        );
      }
    } catch (error) {
      console.error("Payment error details:", {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status,
      });
      const errorMessage =
        error.response?.data?.message ||
        error.response?.data?.error ||
        t("paymentError") ||
        "Payment error. Please try again.";
      alert(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="py-8 px-4 bg-white">
      <div className="text-center">
        <h3 className="text-lg font-semibold mb-4">
          {t("completeYourPayment")}
        </h3>
        <p className="text-gray-600 mb-6">{t("chapaRedirectMessage")}</p>
        <button
          onClick={initiate_payment}
          disabled={loading}
          className={`px-10 py-3 rounded-sm ${
            loading
              ? "bg-gray-400 cursor-not-allowed"
              : "bg-green-600 hover:bg-green-700 hover:shadow-lg"
          } text-white font-medium transition-all duration-300`}
        >
          {loading ? (
            <span className="flex items-center justify-center">
              <svg className="animate-spin h-5 w-5 mr-3" viewBox="0 0 24 24">
                <circle
                  className="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                />
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                />
              </svg>
              {t("processing")}
            </span>
          ) : (
            t("payWithChapa")
          )}
        </button>
        <div className="mt-6">
          {/* <img
            src="https://chapa.co/asset/images/chapa_swirl.svg"
            alt="Chapa"
            className="h-8 mx-auto"
          /> */}
          <p className="text-xs text-gray-500 mt-2">
            {t("securePaymentByChapa")}
          </p>
        </div>
      </div>
    </div>
  );
};

export default Chapa;
